import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { setsnackBar } from '../reducers/global-reducer';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars({ open, message, severity }) {
    const dispatch = useDispatch()
   

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch(setsnackBar({
            message:'',
            open:false,
            severity:''
        }))
    };

    return (
        <>
        {message === ""?null : <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
            <Alert 
                onClose={handleClose} 
                style={{backgroundColor: `${severity === "error" && 'red'}`, color: `${severity === "error" && 'grey'}`, fontWeight: `bold`, border: `${severity === "error" && '3px solid grey'}`}} 
                severity={severity} 
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>}</>
    );
}
